import React, { Component } from 'react';
import {
  FormCard, FormTextInput, Container, Grid, Alert,
} from 'tabler-react';
import { router } from '../routes';
import { IsLoggedIn, AuthFunctions } from './Auth';


class LoginForm extends Component {
  state = { token: '', password: '', error: null };

  onChange = fieldname => ({ target: { value } }) => {
    this.setState({ [fieldname]: value });
  }

  componentDidMount() {
    const urlParams = new URLSearchParams(window.location.search);
    const token = urlParams.get('token');
    this.setState({ token });
  }

  onResetPassword = async (e) => {
    e.preventDefault();
    const { token, password } = this.state;
    try {
      await this.props.resetPassword({ token, password });
      router.navigate({ name: 'Home' });
    } catch (e) {
      this.setState({ error: e.message.replace('GraphQL error: ', '') });
    }
  }

  render() {
    return (
      <Container>
        <Grid.Row>
          <Grid.Col className="mx-auto mt-6 col-login">
            <FormCard onSubmit={this.onResetPassword} title="Reset Password" buttonText="Reset Passowrd">
              { this.state.error && <Alert type="danger">{this.state.error}</Alert> }
              <FormTextInput
                onChange={this.onChange('password')}
                label="New Password"
                placeholder="Password"
                name="Password"
                type="password"
              />
            </FormCard>
          </Grid.Col>
        </Grid.Row>
      </Container>
    );
  }
}

export default () => (
  <IsLoggedIn>
    {isLoggedIn => (
      <AuthFunctions>
        {({ changePassword }) => (
          <LoginForm loggedIn={isLoggedIn} resetPassword={changePassword} />
        )}
      </AuthFunctions>
    )}
  </IsLoggedIn>
);



// WEBPACK FOOTER //
// ./src/auth/PasswordReset.js